"use strict";

Shopify.theme.jsSlideshowClassic = {
  
init: function init($section) {
  if (!$section || !$section.length || !window.jQuery || !$.fn || !$.fn.flickity) return;

  var $slideshowClassicEl = $section.find('[data-slideshow-classic]').removeClass('is-hidden');

  // Prevent the same slideshow from being initialized more than once.
  if (!$slideshowClassicEl.length || $slideshowClassicEl.hasClass('flickity-enabled')) return;

  Shopify.theme.jsSlideshowClassic = $.extend(this, Shopify.theme.getSectionData($section));



    var autoplayMs = this.image_slideshow_speed * 1000;

    function loadSlideImage($cell) {
      if (!$cell || !$cell.length) return;
      $cell.find('source[data-affled-srcset]').each(function () {
        var value = this.getAttribute('data-affled-srcset');
        if (value) {
          this.setAttribute('srcset', value);
          this.removeAttribute('data-affled-srcset');
        }
      });
      $cell.find('img[data-affled-src]').each(function () {
        var srcset = this.getAttribute('data-affled-srcset');
        var src = this.getAttribute('data-affled-src');
        if (srcset) this.setAttribute('srcset', srcset);
        if (src) this.setAttribute('src', src);
        this.removeAttribute('data-affled-srcset');
        this.removeAttribute('data-affled-src');
        this.classList.remove('affled-slide-lazy');
        this.classList.add('lazyloaded');
      });
    }

    function updateSlideFocus(flkty) {
      if (!flkty || !flkty.cells) return;
      flkty.cells.forEach(function (cell, index) {
        var focusables = cell.element.querySelectorAll('a, button, input, select, textarea, [tabindex]');
        Array.prototype.forEach.call(focusables, function (el) {
          if (index === flkty.selectedIndex) {
            if (el.getAttribute('data-affled-hidden-tab') === '1') {
              el.removeAttribute('tabindex');
              el.removeAttribute('data-affled-hidden-tab');
            }
          } else if (!el.hasAttribute('tabindex')) {
            el.setAttribute('tabindex', '-1');
            el.setAttribute('data-affled-hidden-tab', '1');
          }
        });
      });
    }

    var $slideshowClassic = $slideshowClassicEl.flickity({
      wrapAround: true,
      adaptiveHeight: true,
      prevNextButtons: this.number_of_slides > 1 ? this.show_arrows : false,
      pageDots: this.number_of_slides > 1 ? this.show_nav_buttons : false,
      draggable: true,
      imagesLoaded: true,
      fade: this.image_transition == 'fade' ? true : false,
      autoPlay: false,
      arrowShape: arrowShape
    });

    var flkty = $slideshowClassicEl.data('flickity');
    updateSlideFocus(flkty);

    $slideshowClassicEl.on('select.flickity', function () {
      var instance = $slideshowClassicEl.data('flickity');
      if (!instance) return;
      loadSlideImage($(instance.selectedElement));
      updateSlideFocus(instance);
    });

    $slideshowClassicEl.on('settle.flickity', function () {
      $slideshowClassicEl.flickity('resize');
    });

    if (this.number_of_slides > 1 && autoplayMs > 0) {
      var autoplayStarted = false;
      function startAutoplayAfterIntent() {
        if (autoplayStarted) return;
        autoplayStarted = true;
        var instance = $slideshowClassicEl.data('flickity');
        if (!instance) return;
        var nextIndex = (instance.selectedIndex + 1) % instance.cells.length;
        loadSlideImage($(instance.cells[nextIndex].element));
        instance.options.autoPlay = autoplayMs;
        if (instance.player && instance.player.play) instance.player.play();
      }
      ['pointerdown', 'keydown', 'touchstart'].forEach(function (evt) {
        window.addEventListener(evt, startAutoplayAfterIntent, { once: true, passive: true });
      });
    }
  },
  blockSelect: function blockSelect($section, blockId) {
    var $slider = $section.find('[data-slideshow-classic]');
    var $sliderIndex = $('#shopify-section-' + blockId).data('slide-index');
    $slider.flickity('select', $sliderIndex, true, true);
  },
  unload: function unload($section) {}
};
/* AffordableLED V6.1 cold-load safeguard.
   Retry slideshow initialization if the normal theme scan occurred
   before this deferred module became available. */
(function () {
  var attempts = 0;
  var maxAttempts = 20;

function bootSlideshowClassic() {
  // Desktop-only cold-load retry. Mobile keeps the normal V6 behavior.
  if (window.matchMedia('(max-width: 798px)').matches) return;

  if (!window.jQuery || !window.Shopify || !Shopify.theme ||
        !Shopify.theme.jsSlideshowClassic || !jQuery.fn || !jQuery.fn.flickity) {
      if (attempts++ < maxAttempts) {
        window.setTimeout(bootSlideshowClassic, 100);
      }
      return;
    }

    var pending = false;

    jQuery('.jsSlideshowClassic').each(function () {
      var $section = jQuery(this);
      var $slider = $section.find('[data-slideshow-classic]');

      if (!$slider.length || $slider.hasClass('flickity-enabled')) return;

      try {
        Shopify.theme.jsSlideshowClassic.init($section);
      } catch (e) {
        pending = true;
      }
    });

    if (pending && attempts++ < maxAttempts) {
      window.setTimeout(bootSlideshowClassic, 100);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootSlideshowClassic, { once: true });
  } else {
    bootSlideshowClassic();
  }

  window.addEventListener('load', bootSlideshowClassic, { once: true });
  window.addEventListener('pageshow', bootSlideshowClassic);
})();